// extracted by mini-css-extract-plugin
export default {"header":"PortfolioProjectListTable_header__eV0aa","row__nameCell":"PortfolioProjectListTable_row__nameCell__7vnoH"};